import { HttpRequest } from '@angular/common/http';

/**
 * ¿La request va a nuestra API? Compara contra `apiUrl` + `/`: un `startsWith(apiUrl)` a secas
 * también aceptaría `https://api.ejemplo.com.otro-dominio.com`.
 */
export function isApiRequest(req: HttpRequest<unknown>, apiUrl: string): boolean {
  return req.url.startsWith(`${apiUrl}/`);
}
